import { PAGINATION_MAPPINGS } from '../../constants/table.constants';
import { TEMPLATE_CATEGORIES_OPTIONS } from '../../constants/templates.constants';
import { toReadableTemplateFileKey } from '../../lib/template.utils';
import { templates } from '../../services/bff.api';

export const ADMIN_TEMPLATES_RESOURCE = {
  key: 'ADMIN_TEMPLATES_RESOURCE',
  table: {
    defaultSort: 'name',
    dataLocation: '_embedded.templates',
    searchParams: ['name'],
    fields: [
      { value: 'name', label: 'Naam', show: true, order: 0 },
      { value: 'category', label: 'Categorie', show: true, order: 1 },
      { value: 'fileKey', label: 'Bestand', show: true, blockSort: true, order: 2 }
    ],
    dataTransform: (data) =>
      data?.map((i) => {
        return {
          ...i,
          category: TEMPLATE_CATEGORIES_OPTIONS.find((opt) => opt.value === i?.category)?.label ?? i?.category ?? '',
          categoryValue: i?.category,
          fileKey: toReadableTemplateFileKey(i?.fileKey)
        };
      }),
    pageMapping: PAGINATION_MAPPINGS.DEFAULT
  },
  api: {
    get: templates.getAll
  }
};
